import React, { useState, useContext, useEffect }from 'react';
import { useIonRouter, IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonRefresher, IonRefresherContent, IonModal, IonText  } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { helpCircleOutline, menuOutline } from 'ionicons/icons';

//import { SelectDateRange } from '../components/SelectDateRange';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
//import { App_Footer } from '../components/App_Footer';

import '../../../css/layout.css';


import { useHistory} from "react-router-dom";

import { Modal_UpdateDeliveryFee} from './Modal_Update_DeliveryFee';
import { CreateDeliveryFeeModal} from './Modal_CreateDeliveryFee';


 export function Modal_DeliveryFee (props) {

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAccountID ] = useState(authMerchant_objects.acctID);
    let [employeeID, setEmployeeID ] = useState(authMerchant_objects.employeeID);
    let [schema, setSchema ] = useState(authMerchant_objects.schema);
    let [access, setAccessRights ] = useState(authMerchant_objects.accessRights);
    let [sessionID, setSessionID ] = useState(authMerchant_objects.sessionID);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    let [viewDeliveryFeeList, setViewDeliveryFeeList] = useState([]);
    let [deliveryFeeID, setDeliveryFeeID] = useState('');
    let [itemID, setItemID] = useState('');
    let [deliveryAmount, setDeliveryAmount] = useState('');
    let [deliveryCity, setDeliveryCity] = useState('');
    let [deliveryCityDistrict, setDeliveryCityDistrict] = useState('');
    let [deliveryRegion, setDeliveryRegion] = useState('');
    let [deliveryCountry, setDeliveryCountry] = useState('');

    let [deliveryFeeModal, setDeliveryFeeModal] = useState(props.openModal);
    
    let [viewUpdateDeliveryFeeModal, setViewUpdateDeliveryFeeModal] = useState(false);
    let [viewCreateDeliveryFeeModal, setViewCreateDeliveryFeeModal] = useState(false);

    let [saveDisabled, setSaveDisabled] = useState(true);

    const isInvalid = (v) => ['', 'null', 'NULL', 'undefined'].includes(v);

    let history = useHistory();
    let router = useIonRouter();



    useEffect(() => {
        

        setViewDeliveryFeeList([]);


            const requestOptions = {
                method:'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    },
                body: JSON.stringify({
                    Tracker: "33_delivery_fee_list",
                    user: acctID,
                    sessionID: sessionID,

                })            }
    
            //alert('In ghanaverifiedApp - HotelList UseEffect');

            fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');
                for(let rowNum = 0; rowNum < rows.length - 1; ++rowNum)
                {
                    let cols = rows[rowNum].split('|');
 

                    setViewDeliveryFeeList((prevViewDeliveryFeeList) => {
                        return prevViewDeliveryFeeList.concat({
                            deliveryFeeID: cols[0],
                            itemID: cols[1],
                            deliveryAmount: cols[2],
                            deliveryCity: cols[3],
                            deliveryCityDistrict: cols[4],
                            deliveryRegion: cols[5],
                            deliveryCountry: cols[6],
                            date_created: cols[7],
                            product_id: cols[8],

                        })

                    });
                }

                //props.confirmComplete();
                //setSaveDisabled(false);
            })
    }, []);

    function viewDeliveryFeeDetailsHandler(event) {

        setDeliveryFeeID(event[0]);
        setItemID(event[1]);
        setDeliveryAmount(event[2]);
        setDeliveryCity(event[3]);
        setDeliveryCityDistrict(event[4]);
        setDeliveryRegion(event[5]);
        setDeliveryCountry(event[6]);

        setViewUpdateDeliveryFeeModal(true);
        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    return (
            <React.Fragment>
                        <IonModal isOpen={ props.openModal }>
                            <IonHeader style={{ color: "black" }}>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <h3> DELIVERY FEE LIST </h3>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonButton onClick={() => setViewCreateDeliveryFeeModal(true)}> Create Delivery Fee </IonButton>                                    
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>

                    <IonContent >
                        <IonGrid className='appGridContent'>
                            <IonRow >
                                    <IonCol size='2'> <h3> Fee ID </h3> </IonCol>
                                    <IonCol size='2'> <h3> Amount </h3> </IonCol>
                                    {/*<IonCol className='appGridCol' size='3'> <h3> Estimate Description </h3> </IonCol>*/}
                                    <IonCol size='5'> <h3> City </h3> </IonCol>
                                    <IonCol size='3'> <h3> Action </h3> </IonCol>
                            </IonRow>
                        {viewDeliveryFeeList.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.deliveryFeeID}>
                                        <IonCol size='2'>{detailData.deliveryFeeID}</IonCol>
                                        <IonCol size='2'>{detailData.deliveryAmount}</IonCol>
                                        {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                        <IonCol size='5'>{detailData.deliveryCity}</IonCol>
                                        <IonCol size='3'>
                                            {/*<IonButton class='gridResultColumnButton' onClick={() => viewInvoiceModalHandler([true, detailData.orderID, detailData.invoiceTotal, detailData.invoiceForm])}> View </IonButton>*/}
                                            <IonButton onClick={() => viewDeliveryFeeDetailsHandler([detailData.deliveryFeeID, detailData.itemID, detailData.deliveryAmount, detailData.deliveryCity, detailData.deliveryCityDistrict, detailData.deliveryRegion, detailData.deliveryCountry])}> Details </IonButton>                                    
                                        </IonCol>
                                    </IonRow>
                            )
                        }
                        )}
                            </IonGrid>
                            </IonContent>
                            <IonFooter className='grid_footer'>
                                <IonGrid>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonButton  onClick={() => props.closeModal()}>Cancel</IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </IonFooter>
                        </IonModal>



                    {viewUpdateDeliveryFeeModal == true && <Modal_UpdateDeliveryFee openModal={viewUpdateDeliveryFeeModal} closeModal={() => setViewUpdateDeliveryFeeModal(false)} data={{
                    deliveryFeeID: deliveryFeeID, 
                    itemID: itemID, 
                    deliveryAmount: deliveryAmount,
                    deliveryCity: deliveryCity,
                    deliveryCityDistrict: deliveryCityDistrict,
                    deliveryRegion: deliveryRegion,
                    deliveryCountry: deliveryCountry,
                    }}></Modal_UpdateDeliveryFee>}

                    {viewCreateDeliveryFeeModal == true && <CreateDeliveryFeeModal openModal={ viewCreateDeliveryFeeModal } closeModal={() => setViewCreateDeliveryFeeModal(false)}></CreateDeliveryFeeModal>}


            </React.Fragment>

    );
};



export default Modal_DeliveryFee;